module.exports = __webpack_public_path__ + "img/mid.cb8e035b.svg";